import React from 'react';
import PropTypes from 'prop-types';
import css from './TenantEnabledToggle.css';
import Switch from "../common/Switch";

/**
 * Displays the checkbox that enables data extracts for a tenant on the Data Extracts Tenant Admin page.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The component containing the checkbox that enables data extracts tenant admin Data Extracts page
 */
const TenantEnabledToggle = (props) => {
    return <div className={css["toggle"]}>
                <Switch aria-labelledby="enable-data-extracts"
                        checked={props.checked}
                        onChange={() => {
                            props.setSaveTenantEnabledFlagSuccess(false)
                            props.saveTenantEnabledFlag(!props.checked)
                        }}
                        data-testid="tenant-enabled-checkbox"/>
                <label id="enable-data-extracts">Enable Data Extracts</label>
          </div>;
}

TenantEnabledToggle.propTypes = {
    checked: PropTypes.bool.isRequired,
    setTenantEnabled: PropTypes.func.isRequired,
    saveTenantEnabledFlag: PropTypes.func.isRequired,
    setSaveTenantEnabledFlagSuccess: PropTypes.func.isRequired
};

export default TenantEnabledToggle;
